/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class FacebookInput extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    {...this.props}
                    error={this.props.error}
                    headerCopy={<span>Post Items <strong>from</strong> this Facebook Page</span>}/>
                <ChooserMain
                    {...this.props}
                    allConnectedMessage={"You've already connected all your pages to dlvr.it"}
                    unavailableMessage={"Facebook Pages you've already connected"}
                    typeLabel="page"/>
            </div>
        );
    }
}

FacebookInput.displayName = "FacebookInput";

export default FacebookInput;
